import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { createParams, SharedService } from 'src/app/core/services/shared.service';
import {
  IndividualPEP,
  BeneficialOwnerPEP,
  CreateIndividualManualPepCheck,
  CreateIndividualManualPepCheckResult
} from './pep-list.interface';
import { BackendResponse } from 'src/app/core/interfaces/shared.interface';

@Injectable({
  providedIn: 'root'
})
export class PepListService {
  constructor(private http: HttpClient, private sharedService: SharedService) {}

  getBeneficialOwnersPEPList(params?: Record<string, any>) {
    return this.http.get<BackendResponse<BeneficialOwnerPEP>>(`${this.sharedService.baseUrl}bankid/beneficial-owner-pep`, {
      params: createParams(params || {})
    });
  }

  getIndividualsPEPList(params?: Record<string, any>) {
    return this.http.get<BackendResponse<IndividualPEP>>(`${this.sharedService.baseUrl}bankid/pep-check`, {
      params: createParams(params || {})
    });
  }

  getLatestBeneficialOwnersPEPList(params?: Record<string, any>) {
    return this.http.get<BackendResponse<BeneficialOwnerPEP>>(`${this.sharedService.baseUrl}bankid/beneficial-owner-pep/latest`, {
      params: createParams(params || {})
    });
  }

  getLatestIndividualsPEPList(params?: Record<string, any>) {
    return this.http.get<BackendResponse<IndividualPEP>>(`${this.sharedService.baseUrl}bankid/pep-check/latest`, {
      params: createParams(params || {})
    });
  }

  createPepCheck(payload: CreateIndividualManualPepCheck) {
    return this.http.post<CreateIndividualManualPepCheckResult>(`${this.sharedService.baseUrl}bankid/pep-check/manual`, payload);
  }
}
